import React from 'react';

import { Mark } from './styles';

export const RequiredMark = () => (<Mark>*</Mark>);
